<template>
  <main class="offer-details u-container">
    <component
      :is="templateComponent"
      v-if="offsrc && offer && templateComponent"
      :ad-id="offer.id"
      :ad-group-id="offer.adGroupId"
      :account-id="offer.accountId"
      :template-id="template.id"
      :background-url="template.properties.backgroundUrl"
      :background-url-two="template.properties.backgroundUrlTwo"
      :background-url-three="template.properties.backgroundUrlThree"
      :barcode="template.properties.barcode"
      :borderless="template.properties.borderless"
      :expiration="template.properties.expiration"
      :headline-url="template.properties.headlineUrl"
      :legal-text="template.properties.legalText"
      :logo-url="template.properties.logoUrl"
      :promo-code="template.properties.promoCode"
      :promo-code-two="template.properties.promoCodeTwo"
      :promo-code-three="template.properties.promoCodeThree"
      :promo-code-label="template.properties.promoCodeLabel"
      :promo-code-label-two="template.properties.promoCodeLabelTwo"
      :promo-code-label-three="template.properties.promoCodeLabelThree"
      :tagline="template.properties.tagline"
      @print="printOffer"
    />
  </main>
</template>

<script>
import { AdvantagePrintDefault } from '@ampersend/mgo';
import offerDetailsMixin from './mixin';

export default {
  name: 'OfferDetails',
  components: {
    AdvantagePrintDefault,
  },
  mixins: [offerDetailsMixin],
  async mounted() {
    // workaround for MGOD-8172 - Vue event not working
    window.setTimeout(() => {
      const printBtn = document.querySelector('.mva-print__button');
      if (printBtn) {
        printBtn.setAttribute('onclick', 'window.print()');
      }
    }, 1000);
  },
};
</script>
